import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { isXcxWeb } from '@ivy/fts/utils';
let MyLogistics = class MyLogistics extends Vue {
    constructor() {
        super(...arguments);
        this.isXcxWeb = isXcxWeb();
        this.show = false;
        this.tid = '';
        this.express_list = null;
        this.curExpress = null;
    }
    created() {
        this.tid = this.$route.query.tid;
        this.getData();
    }
    async getData() {
        await this.$store.login();
        let { data } = await this.$axios.get(`/api/goods/shop/search/delivery/queryExpress`, {
            params: {
                tid: this.tid,
            },
        });
        this.express_list = data.express_list || [];
        this.curExpress = this.express_list[0];
        this.show = true;
    }
    changeItem(item) {
        this.show = !this.show;
        setTimeout(() => {
            this.show = !this.show;
            this.curExpress = item;
        }, 0);
    }
};
MyLogistics = tslib_1.__decorate([
    Component({
        components: {
            CustomerButton: () => import('@ivy/fts/comps/Customer'),
        },
    })
], MyLogistics);
export default MyLogistics;
